import { Form, Radio, Row, Space, Spin, Table } from 'antd';
import { SelectForm } from 'components';
import TableComponent from 'components/Table/TableComponent';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import React, { useEffect, useState } from 'react';
import formatNumber, {
  formatCurrency,
  generateUUID,
} from 'utils/constants/functions';
import { OrderDebitType, PurchaseDebitType } from './DetailPaymentSummaryPage';

interface IProps {
  form: any;
  customerId: any;
  saleOrdersData: any;
  saleOrderSelected: any;
  setSaleOrderSelected: (value: any) => void;
  loading: boolean;
  refetchSumPayment: (
    dataNewSaleOrder?: any,
    dataNewPurchaseOrder?: any,
  ) => any;
  lockYn?: boolean;
  purchaseType?: string;
}

const TabSalesInvoice = (props: IProps) => {
  const {
    saleOrdersData,
    saleOrderSelected,
    form,
    customerId,
    setSaleOrderSelected,
    refetchSumPayment,
    loading,
    lockYn,
    purchaseType,
  } = props;

  const columns: ColumnsTypeCustom = [
    {
      title: 'Tuổi vàng',
      width: 100,
      dataIndex: 'age',
      align: 'right',
      render: (value: any) => formatNumber(value),
    },
    {
      title: 'TL Tuổi vàng(chỉ)',
      width: 150,
      dataIndex: 'totalGoldWeightThread',
      align: 'right',
      render: (value: any) => formatNumber(value),
      //      render: (value: any) => formatNumber(value),
    },
    {
      title: 'TL Q10(chỉ)',
      width: 100,
      dataIndex: 'totalq10',
      align: 'right',
      render: (value: any) => formatNumber(value),
    },
    {
      title: 'Hao lai(chỉ)',
      width: 100,
      dataIndex: 'totalHaolai',
      align: 'right',
      render: (value: any) =>
        formatCurrency({
          value: Number(Number(value).toFixed(4)),
          format: 4,
        }),
    },
    {
      title: 'Q10 tổng',
      width: 100,
      dataIndex: 'totalq10T',
      align: 'right',
      render: (value: any) => formatNumber(value),
    },
    {
      title: 'Thành tiền món',
      width: 185,
      dataIndex: 'totalUnitPrice',
      align: 'right',
      render: (value: any) => formatNumber(value),
    },
    {
      title: 'Thành tiền công',
      width: 185,
      dataIndex: 'totalprocessPrice',
      align: 'right',
      render: (value: any) => formatNumber(value ?? 0),
    },
    {
      title: 'Thành tiền vàng',
      width: 185,
      dataIndex: 'totalFinalPrice',
      align: 'right',
      render: (value: any) => formatNumber(value),
    },
  ];

  const options = (saleOrdersData?.listSaleOrder || []).map((item: any) => ({
    label: item.order_id,
    value: item.order_id,
  }));

  useEffect(() => {
    // setSaleOrderSelected([]);
    // form.setFieldsValue({ saleOrder: [] });
    // console.log('saleOrdersData', saleOrdersData);
  }, [saleOrdersData]);

  return (
    <Spin spinning={loading}>
      <Row gutter={16}>
        <Form.Item name={'orderType'} className="mb-2 ml-2">
          <Radio.Group
            disabled={lockYn}
            onChange={(e) => {
              refetchSumPayment();
            }}
          >
            <Radio value={OrderDebitType.Q10}>Công nợ Q10</Radio>
            <Radio value={OrderDebitType.Amount}>Nợ Tiền</Radio>
          </Radio.Group>
        </Form.Item>
      </Row>
      <Form.Item name="saleOrder" className="mb-3">
        <SelectForm
          mode="multiple"
          placeholder="Chọn bảng kê"
          options={options}
          disabled={
            lockYn ||
            !customerId ||
            purchaseType === PurchaseDebitType.ReturnCustomer
          }
          //   onDeselect={handleDeselect}
          onChange={(value: any) => setSaleOrderSelected(value)}
        />
      </Form.Item>
      <TableComponent
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={saleOrdersData?.groupSaleOrder}
        rowKey={(record: any) => record?.id || generateUUID()}
        // loading={loading}
        pagination={false}
        summary={(pageData) => {
          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} align="end" className="font-bold">
                  Tổng
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="end" className="font-bold">
                  {formatNumber(
                    saleOrdersData?.totalGroupSaleOrder
                      ?.totalGoldWeightThread || 0,
                  )}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="end" className="font-bold">
                  {formatNumber(
                    saleOrdersData?.totalGroupSaleOrder?.totalq10 || 0,
                  )}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} align="end" className="font-bold">
                  {formatNumber(
                    saleOrdersData?.totalGroupSaleOrder?.totalHaolai || 0,
                  )}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4} align="end" className="font-bold">
                  {formatNumber(
                    saleOrdersData?.totalGroupSaleOrder?.totalq10T || 0,
                  )}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5} align="end" className="font-bold">
                  {formatNumber(
                    saleOrdersData?.totalGroupSaleOrder?.totalUnitPrice || 0,
                  )}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} align="end" className="font-bold">
                  {formatNumber(
                    saleOrdersData?.totalGroupSaleOrder?.totalprocessPrice || 0,
                  )}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7} align="end" className="font-bold">
                  {formatNumber(
                    saleOrdersData?.totalGroupSaleOrder?.totalFinalPrice || 0,
                  )}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
    </Spin>
  );
};

export default TabSalesInvoice;
